// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".s-module__wrap--kjhhh .s-module__content--aQjFS {\n  margin-top: 24px;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/dashboard/PrescriptionsPage/PrescriptionsRegisterPage/components/ScriptSureOnboarding/s.module.less"],"names":[],"mappings":"AAAA;EAEI,gBAAA;AAAJ","sourcesContent":[".wrap {\n  .content {\n    margin-top: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": "s-module__wrap--kjhhh",
	"content": "s-module__content--aQjFS"
};
export default ___CSS_LOADER_EXPORT___;
